import React, { useEffect, useState } from "react";
import {
    IonRadioGroup,
    IonRadio,
    IonItem,
    IonLabel,
    IonText,
} from "@ionic/react";

interface GroupingQuestion {
    question: string;
    pattern: (string | null)[];
    options: string[];
    correctAnswer: string;
    type: "image";
}

const getRandomInt = (min: number, max: number): number =>
    Math.floor(Math.random() * (max - min + 1)) + min;

function getRandomItems<T>(arr: T[], count: number): T[] {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
}

const patternBackground = {
    "animals": ["elephant.png", "zebra.png", "monkey.png", "horse.png", "wolf.png", "yak.png", "tiger.png", "lion.png", "snake.png", "sheep.png", "rhino.png", "kangaroo.png", "rat.png", "rabbit.png", "dog.png", "cat.png", "cow.png", "pig.png", "fox.png", "lemur.png", "leopard.png", "joey.png", "gorilla.png", "goat.png", "giraffe.png", "donkey.png", "cheetah.png", "camel.png", "buffalo.png", "bison.png", "bear.png"],
    "insects": ["butterfly.png", "bee.png", "spider.png", "ant.png", "ladybug.png", "mosquito.png", "grasshoper.png", "dragonfly.png", "beetle.png", "caterpillar.png", "wasp.png", "moth.png", "cricket.png", "firefly.png", "termite.png", "leafhopper.png"],
    "flowers": ["sunflower.png", "lotus.png", "rose.png", "lily.png", "daisy.png", "tulip.png", "marigold.png", "jasmine.png", "hibiscus.png", "daffodil.png", "poppy.png", "lavender.png", "orchid.png", "dahlia.png", "aster.png", "magnolia.png"],
    "vehicles": ["car.png", "bicycle.png", "airplane.png", "ambulance.png", "bike.png", "bus.png", "truck.png", "motorcycle.png", "scooter.png", "firetruck.png", "train.png", "policecar.png", "jeep.png", "rickshaw.png", "ship.png", "boat.png", "yacht.png"],
    "things": ["binoculars.png", "book.png", "candles.png", "ball.png", "dolls.png", "pencil.png", "eraser.png", "crayon.png", "schoolbag.png", "chair.png", "table.png", "cup_image.png", "clock.png", "mug.png", "scissors.png", "sharpener.png"]
};


const Grouping: React.FC = () => {
    const [showImage, setShowImage] = useState(false);
    const [question, setQuestion] = useState<GroupingQuestion | null>(null);
    const [selected, setSelected] = useState<string | null>(null);
    const [selectedNearFarBackground, setSelectedNearFarBackground] = useState<string | null>(null);
    const [selectedElement, setSelectedElement] = useState<string | null>(null);

    const createNewQuestion = () => {
        const patternType = getRandomInt(0, 1);
        const q = generateImageGrouping();
        setQuestion(q);
        setSelected(null);
    }

    const generateImageGrouping = (): GroupingQuestion => {
        const unitLength = 10;
        const categories = Object.keys(patternBackground) as (keyof typeof patternBackground)[]; 
        const randomCategory = categories[Math.floor(Math.random() * categories.length)];

        const totalGroups = getRandomInt(2, 4);
        const groupSize = getRandomInt(2, 6);

        const totalItems = totalGroups * groupSize;

        const selectedTopic = patternBackground[randomCategory];
        const totalLength = 1;

        const patternUnit = getRandomItems(selectedTopic, totalLength);
        setSelectedElement(patternUnit[0]);

        const pattern = Array(totalItems).fill(patternUnit[0]);
        const itemName = patternUnit[0].split('.')[0];

        const options = new Set<string>();
        

        const questionType = getRandomInt(1, 4);
        let question = "";
        let correctAnswer = "";

        if (questionType === 1) {
            question = `There are  ____________ equal groups of ${groupSize} ${itemName}(s) each.`;
            correctAnswer = totalGroups.toString();
        }
        else if (questionType === 2) {
            question = `How many groups of ${groupSize} ${itemName}(s) each can be formed from the given ${itemName}(s)?`;
            correctAnswer = totalGroups.toString();
        }
        else if (questionType === 3) {
            question = ` ____________ groups of ${groupSize} ${itemName}(s) each can be formed from the given ${itemName}(s)?`;
            correctAnswer = totalGroups.toString();
        }
        else {
            question = `${totalGroups} groups of  ____________ ${itemName}(s) each can be formed from the given ${itemName}(s)?`;
            correctAnswer = groupSize.toString();
        }
        options.add(correctAnswer);
        while (options.size < 4) {
            const distractor = getRandomInt(1, 7).toString();
            if (!options.has(distractor)) {
                options.add(distractor);
            }
        }

        return {
            question,
            pattern,
            options: Array.from(options).sort(() => Math.random() - 0.5),
            correctAnswer,
            type: "image",
        };
    }

    const handleAnswer = (value: string) => {
        if (!question) return;
        setSelected(value);
        if (value === question.correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setShowImage(false);
                createNewQuestion();
            }, 3000);
        }
    };

    useEffect(() => {
        createNewQuestion();
        document.title =
            "Mamas Guidance - OLYMPIAD - Class One - Logical Reasoning - Grouping";
    }, []);

    return (
        <>
            {!showImage ? (
                <div className="contentPart  fillPreposition additionWord rankingTest" style={{ marginTop: "0" }}>
                    <div className='mb-5'>
                        <div className='mb-5'>
                            {question?.type == "image" ?
                                (
                                    <>
                                        <div className="image-container" style={{fontSize: "22px"}}>
                                            {question?.question}
                                        </div>
                                    </>
                                ) :
                                (
                                    <p>
                                        {question?.question}</p>
                                )}
                        </div>
                        <IonText>
                            <div className="mb-2" style={{ fontSize: "1.2rem" }}>
                                {question?.type == "image" && question.pattern.map((val, idx) => (
                                    <div key={idx} className="image-container">
                                        <img className="repeating"
                                            src={`${process.env.REACT_APP_API_URL ?? ""}${val ?? "question-mark.png"}`}
                                            alt="pattern-img"
                                        />
                                    </div>
                                ))}
                            </div>
                        </IonText>
                        <IonRadioGroup className="mb-5 displayFlex"
                            value={selected}
                            onIonChange={(e) => handleAnswer(e.detail.value)}
                        >
                            {question?.options.map((option, idx) => (
                                <IonItem
                                    key={idx}
                                    className={`mygrid grid-item ${selected === option
                                        ? option === question.correctAnswer
                                            ? "correct"
                                            : "errorOptions"
                                        : ""
                                        }`}
                                >
                                    <IonLabel style={(question.type !== "image") ? {} : { width: "auto" }}>
                                        {
                                            question.type === "image" ? (
                                                <span>{option}</span>
                                            )
                                                : 

                                                    <></>
                                        }
                                    </IonLabel>
                                    <IonRadio slot="start" value={option} />
                                </IonItem>
                            ))}
                        </IonRadioGroup>
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK ?? ""}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default Grouping;
